<template>
  <div class="border-2 border-gray-800">
    <div class="overflow-hidden text-base bg-gray-800 text-white px-4 py-3">
      <div class="float-left">
        Employment {{ index + 1 }}
      </div>

      <div v-if="(index > 0 && !employment.previous) ||
                 (employment.previous && !isCurrentLessThanThreeYears) ||
                 (employment.previous && isCurrentLessThanThreeYears && numPreviousEmployments > 1)"
        class="float-right">
        <a href="#"
          @click.prevent="deleteEmployment(employment.id, index)"
          class="no-underline text-sm text-white hover:underline">
          <span class="">Delete</span>
        </a>
      </div>
    </div>

    <div class="p-4">
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <EmploymentStatusSelector
            propertyKey="status"
            :value="employment.status"
            objectType="employment"
            :index="index"
            :updateValue="updateValue"
            :required="true" />
        </div>
      </div>

      <template v-if="employment.status != null">
        <div class="flex flex-wrap label-line">
          <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
            <InputDatePicker
              label="Date started"
              propertyKey="date_started_at"
              objectType="employment"
              :maxDate="today"
              :index="index"
              :value="employment.date_started_at"
              :updateValue="updateValue"
              :required="true" />

            <div class="mt-2 text-sm text-red-500" v-if="isStartedLaterThanEnded">
              This should be earlier than date ended
            </div>
          </div>

          <div v-if="employment.previous" class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
            <InputDatePicker
              label="Date ended"
              propertyKey="date_ended_at"
              objectType="employment"
              :index="index"
              :value="employment.date_ended_at"
              :updateValue="updateValue" />
          </div>

          <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
            <div class="label-standard">
              How long there?
            </div>

            <div class="form-line">
              <div class="w-full border bg-gray-200 px-3" style="height:38px;line-height:38px;">
                {{ getEmploymentDuration(employment) }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap label-line">
          <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
            <InputDollarValue
              label="Annual income"
              propertyKey="income"
              objectType="employment"
              :objectId="employment.id"
              :index="index"
              :value="employment.income"
              :updateValue="updateValue"
              :required="true"/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

  import moment                   from 'moment'
  import InputText                from '@/shared/components/form/InputText'
  import RequiredAsterisk         from '@/shared/components/form/RequiredAsterisk'
  import InputDatePicker          from '@/shared/components/form/InputDatePicker'
  import InputDollarValue         from '@/shared/components/form/InputDollarValue'
  import StateSelector            from '@/shared/components/form/StateSelector'
  import CountrySelector          from '@/shared/components/form/CountrySelector'
  import EmploymentStatusSelector from '../EmploymentStatusSelector'
  import BuildingTypeSelector     from '@/shared/components/form/BuildingTypeSelector'

  export default {

    components: {
      InputText,
      RequiredAsterisk,
      InputDatePicker,
      InputDollarValue,
      StateSelector,
      CountrySelector,
      BuildingTypeSelector,
      EmploymentStatusSelector
    },

    props : {
      employment : {
        type    : Object,
        required: true
      },

      updateValue : {
        type : Function,
        required : true,
      },

      objectType : {
        type : String,
        required : false
      },

      index : {
        type : Number,
        required : false
      },

      deleteEmployment : {
        type    : Function,
        required: false
      },

      isCurrentLessThanThreeYears : {
        type : Boolean,
        required : false
      },

      getEmploymentDuration : {
        type : Function,
        required : false,
      },

      numPreviousEmployments : {
        type : Number,
        required : false
      },
    },

    computed : {
      isStartedLaterThanEnded() {
        if(this.employment.date_started_at != null && this.employment.date_ended_at != null && this.employment.date_started_at > this.employment.date_ended_at) {
          return true
        }

        return false
      }
    }
  }
</script>